import { render, staticRenderFns } from "./action-item.vue?vue&type=template&id=6f48988c&scoped=true"
import script from "./action-item.ts?vue&type=script&lang=ts&external"
export * from "./action-item.ts?vue&type=script&lang=ts&external"
import style0 from "./action-item.less?vue&type=style&index=0&id=6f48988c&prod&lang=less&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f48988c",
  null
  
)

export default component.exports